// MapLibre 6 : travailleur construit et hébergé avec l'application, sans service tiers.
// Référence : guide officiel d'installation, section Vite (?worker&url et non ?url).
let chargement: Promise<typeof import('maplibre-gl')> | null = null;

export function chargerMapLibre(): Promise<typeof import('maplibre-gl')> {
  chargement ??= Promise.all([
    import('maplibre-gl'),
    import('maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'),
  ])
    .then(([module, travailleur]) => {
      module.setWorkerUrl(travailleur.default);
      return module;
    })
    .catch((erreur: unknown) => {
      // Une panne transitoire n'interdit pas un nouvel essai au prochain montage.
      chargement = null;
      throw erreur;
    });
  return chargement;
}
